module.exports = __webpack_public_path__ + "img/7.cc56bbb6.png";